export default "__VITE_ASSET__d62c62c2__"